// extracted by mini-css-extract-plugin
module.exports = {"closed":"appointmentsListMobile_closed__2Ivj_","label":"appointmentsListMobile_label__2C_EM","pastList":"appointmentsListMobile_pastList__a7-Cg"};